import { Pipe, PipeTransform } from '@angular/core';
import { TranslationHelperService } from '../services/translation-helper.service';

@Pipe({
  name: 'translateToLocale',
  standalone: true
})
export class TranslateToLocalePipe implements PipeTransform {
  constructor(private _translationHelperService: TranslationHelperService) { }
  transform(value: any, fallback: boolean = true,preferablelocaleString:string = null): any {
    return this._translationHelperService.translateToLocale(value, fallback,preferablelocaleString)
  }

}